import React, { createContext, useContext, useEffect, useState } from "react";

const FontSizeContext = createContext(null);
const SIZES = ["small", "normal", "large"];

export function FontSizeProvider({ children }) {
  const [size, setSize] = useState(() => localStorage.getItem("fontSize") || "normal");

  useEffect(() => {
    const el = document.documentElement;
    el.classList.remove("fs-small", "fs-large");
    if (size === "small") el.classList.add("fs-small");
    if (size === "large") el.classList.add("fs-large");
    localStorage.setItem("fontSize", size);
  }, [size]);

  const dec = () => setSize((s) => SIZES[Math.max(0, SIZES.indexOf(s) - 1)]);
  const reset = () => setSize("normal");
  const inc = () => setSize((s) => SIZES[Math.min(2, SIZES.indexOf(s) + 1)]);

  return (
    <FontSizeContext.Provider value={{ size, dec, reset, inc }}>
      {children}
    </FontSizeContext.Provider>
  );
}

export const useFontSize = () => useContext(FontSizeContext);
